__turbopack_context__.v({
  "className": "barlow_210375be-module__m0y6JG__className",
});
